import { render, staticRenderFns } from "./CheckResult.vue?vue&type=template&id=4bcf1a4c&scoped=true"
import script from "./CheckResult.vue?vue&type=script&lang=js"
export * from "./CheckResult.vue?vue&type=script&lang=js"
import style0 from "./CheckResult.vue?vue&type=style&index=0&id=4bcf1a4c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcf1a4c",
  null
  
)

export default component.exports